import { API_V2 } from '../api';
import {
	AnyActionRequest,
	ContentAuditAction,
	EventAuditAction,
	MessageAuditAction,
	SimpleAuditAction,
	UserEventResourceType,
	BannerAction,
	BannerActionMetadata,
} from './ActionModel';

export function trackAction(params: AnyActionRequest): Promise<void> {
	return API_V2.post('/action', { ...params, version: 2 });
}

/**
 * A simple interface for tracking user actions on GROUPS that
 * require no additional metadata
 */
export function trackGroupSimpleAction(resourceId: string, action: SimpleAuditAction): Promise<void> {
	return trackAction({
		resourceId,
		resourceType: UserEventResourceType.GROUP,
		action,
		metaData: null,
	});
}

/**
 * A simple interface for tracking user actions on EVENTS that
 * require no additional metadata
 */
export function trackEventSimpleAction(resourceId: string, action: SimpleAuditAction): Promise<void> {
	return trackAction({
		resourceId,
		resourceType: UserEventResourceType.EVENT,
		action,
		metaData: null,
	});
}

export function trackGroupContentAction(resourceId: string, contentId: string, action: ContentAuditAction): Promise<void> {
	return trackAction({
		resourceId,
		resourceType: UserEventResourceType.GROUP,
		action,
		metaData: { contentId },
	});
}

export function trackGroupMessageAction(resourceId: string, messageId: string, action: MessageAuditAction): Promise<void> {
	return trackAction({
		resourceId,
		resourceType: UserEventResourceType.GROUP,
		action,
		metaData: { messageId },
	});
}

export function trackGroupEventAction(resourceId: string, eventId: string, action: EventAuditAction): Promise<void> {
	return trackAction({
		resourceId,
		resourceType: UserEventResourceType.GROUP,
		action,
		metaData: { eventId },
	});
}

/**
 * Used to track views of "event banners", so the primary resource is
 * the event whose banner is being viewed. If being viewed on a group's
 * page, then we should also record the groupId in the metaData
 */
export function trackEventBannerAction(
	eventId: string,
	action: BannerAction,
	metaData: BannerActionMetadata,
): Promise<void> {
	return trackAction({
		resourceType: UserEventResourceType.EVENT,
		resourceId: eventId,
		action,
		metaData,
	});
}
